uniform vec3 uColor;
uniform sampler2D uMap;
uniform float uIntensity;

// Point Light uniforms
uniform vec3 uPointLight1Position;
uniform vec3 uPointLight1Color;
uniform float uPointLight1Intensity;
uniform vec3 uPointLight2Position;
uniform vec3 uPointLight2Color;
uniform float uPointLight2Intensity;
uniform vec3 uPointLight3Position;
uniform vec3 uPointLight3Color;
uniform float uPointLight3Intensity;
uniform float uPointLight1Decay;
uniform float uPointLight2Decay;
uniform float uPointLight3Decay;
uniform float uPointLightSpecularPower;

varying vec3 vNormal;
varying vec3 vPosition;
varying vec2 vUv;

#include ../includes/ambientLight.glsl
#include ../includes/directionalLight.glsl
#include ../includes/pointLight.glsl

void main()
{
    vec3 normal = normalize(vNormal);
    vec3 viewDirection = normalize(vPosition - cameraPosition);
    vec3 color = texture2D(uMap, vUv).rgb;

    // Lights
    vec3 light = vec3(0.0);

    light += ambientLight(
        vec3(1.0), // Light color
        uIntensity       // Light intensity
    );
    // Point Light 1
    light += pointLight(
        uPointLight1Color,      // Light color
        uPointLight1Intensity,  // Light intensity
        normal,                 // Normal
        uPointLight1Position,   // Light position
        viewDirection,          // View direction
        uPointLightSpecularPower, // Specular power
        vPosition,              // Position
        uPointLight1Decay       // Light decay
    );

    // Point Light 2
    light += pointLight(
        uPointLight2Color,      // Light color
        uPointLight2Intensity,  // Light intensity
        normal,                 // Normal
        uPointLight2Position,   // Light position
        viewDirection,          // View direction
        uPointLightSpecularPower, // Specular power
        vPosition,              // Position
        uPointLight2Decay       // Light decay
    );

    // Point Light 3
    light += pointLight(
        uPointLight3Color,      // Light color
        uPointLight3Intensity,  // Light intensity
        normal,                 // Normal
        uPointLight3Position,   // Light position
        viewDirection,          // View direction
        uPointLightSpecularPower, // Specular power
        vPosition,              // Position
        uPointLight3Decay       // Light decay
    );

    color *= light;

    color = clamp(color, 0.0, 1.05);

    // Final color
    gl_FragColor = vec4(color, 1.0);
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}